import { Button } from 'antd';
import { setNestedObjectValues, useFormikContext } from 'formik';
import { useCallback } from 'react';

import './VendorLeadBillingInfoLayoutNextButton.scss';

export function VendorLeadBillingInfoLayoutNextButton() {
  const { isSubmitting, isValid, validateForm, submitForm, setTouched } = useFormikContext<unknown>();

  const handleClick = useCallback(async () => {
    const errors = await validateForm();

    if (Object.keys(errors).length === 0) {
      await submitForm();
    } else {
      await setTouched(setNestedObjectValues(errors, true));
    }
  }, [validateForm, submitForm, setTouched]);

  return (
    <Button
      className="vendor-lead-billing-info-step-layout__next-button"
      type="primary"
      size="large"
      disabled={isSubmitting || !isValid}
      loading={isSubmitting}
      onClick={handleClick}
    >
      Submit
    </Button>
  );
}
